import SXMLink from './SXMLink';
export default SXMLink;